"use strict";
// tslint:disable
/**
 * Basic Authentication API
 * An API for authentication and user identity
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationApi = exports.AuthenticationApiFactory = exports.AuthenticationApiFp = exports.AuthenticationApiAxiosParamCreator = void 0;
const globalImportUrl = require('url');
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
const base_1 = require("../base");
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
const AuthenticationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Callback return endpoint for Google authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackForGoogle: async (options = {}) => {
            const localVarPath = `/google/callback`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request to be logged in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (options = {}) => {
            const localVarPath = `/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logs out the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options = {}) => {
            const localVarPath = `/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns user data for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoami: async (options = {}) => {
            const localVarPath = `/whoami`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AuthenticationApiAxiosParamCreator = AuthenticationApiAxiosParamCreator;
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
const AuthenticationApiFp = function (configuration) {
    return {
        /**
         * Callback return endpoint for Google authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackForGoogle(options) {
            const localVarAxiosArgs = await exports.AuthenticationApiAxiosParamCreator(configuration).callbackForGoogle(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Request to be logged in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(options) {
            const localVarAxiosArgs = await exports.AuthenticationApiAxiosParamCreator(configuration).login(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Logs out the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options) {
            const localVarAxiosArgs = await exports.AuthenticationApiAxiosParamCreator(configuration).logout(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns user data for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whoami(options) {
            const localVarAxiosArgs = await exports.AuthenticationApiAxiosParamCreator(configuration).whoami(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
exports.AuthenticationApiFp = AuthenticationApiFp;
/**
 * AuthenticationApi - factory interface
 * @export
 */
const AuthenticationApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Callback return endpoint for Google authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackForGoogle(options) {
            return exports.AuthenticationApiFp(configuration).callbackForGoogle(options).then((request) => request(axios, basePath));
        },
        /**
         * Request to be logged in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(options) {
            return exports.AuthenticationApiFp(configuration).login(options).then((request) => request(axios, basePath));
        },
        /**
         * Logs out the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return exports.AuthenticationApiFp(configuration).logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns user data for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoami(options) {
            return exports.AuthenticationApiFp(configuration).whoami(options).then((request) => request(axios, basePath));
        },
    };
};
exports.AuthenticationApiFactory = AuthenticationApiFactory;
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
class AuthenticationApi extends base_1.BaseAPI {
    /**
     * Callback return endpoint for Google authentication.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    callbackForGoogle(options) {
        return exports.AuthenticationApiFp(this.configuration).callbackForGoogle(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Request to be logged in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    login(options) {
        return exports.AuthenticationApiFp(this.configuration).login(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Logs out the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    logout(options) {
        return exports.AuthenticationApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns user data for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    whoami(options) {
        return exports.AuthenticationApiFp(this.configuration).whoami(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthenticationApi = AuthenticationApi;
//# sourceMappingURL=authentication-api.js.map